import {
    GET_IMAGES,
    GET_RAFTIMAGES,
    RE_LOADING,
    GET_HOME_VIDEO
} from "../actions/CommonActions"

const initialState = {
    images: [],
    homeVideo: {},
    loading: false,
    loadingVideo: false,
};

const CommonReducer = function(state = initialState, action){
    switch (action.type) {
        case RE_LOADING: {
            return {
              ...state,
              loading: true
            }
        }
        case GET_IMAGES: {
            return {
                ...state,
                images: [...action.data],
                loading: false
            }
        }
        case GET_RAFTIMAGES: {
            return {
                ...state,
                images: [...action.data],
                loading: false
            }
        }
        case GET_HOME_VIDEO: {
            return {
                 ...state,
                 homeVideo: action.data,
                 loadingVideo: false
            }
        }
        default: {
            return state;
        }
    }
}

export default CommonReducer;
  

